// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { membersQualifyingLifeEvents } from 'rails_routes'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type CreateQualifyingLifeEventParams = {
  situation: string
  files: File[]
}

type QualifyingLifeEventResponse = {
  id: string
}

export function useCreateQualifyingLifeEvent () {
  return useMutation<QualifyingLifeEventResponse, GrapeAPIErrorType, CreateQualifyingLifeEventParams>({
    mutationFn: async ({ situation, files }) => {
      const formData = new FormData()
      formData.append('qualifying_life_event[situation]', situation)

      // Add files to formData
      files.forEach((file) => {
        formData.append('qualifying_life_event[files][]', file)
      })

      const request = new FetchRequest('post', membersQualifyingLifeEvents.create(), {
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      })
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
